export var MuiButtonBase = {
  defaultProps: {
    disableRipple: true
  }
};
//# sourceMappingURL=MuiButtonBase.js.map